<template>
  <div class="detail_wrapper">
    <div class="title_wrapper">
      <span class="config_title">名称</span>
      <Input class="title_ipt" v-model="configTitle"/>
    </div>
    <div class="selection_list_wrapper">
      <div class="selection_item">
        <span class="item_label">题型</span>
        <Select v-model="selectedQuestionType" class="select_info" multiple>
          <Option v-for="item in questionTypeList" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="selection_item" v-for="(value,name,index) in basicsConfigList">
        <span class="item_label">{{name}}</span>
        <Select v-model="name" class="select_info" multiple :max-tag-count="2">
          <Option v-for="item in value" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
    </div>
    <div class="subject_list_wrapper">
      <span :class="[currentSelectedSubject == index ? 'subject_item subject_item_active' :'subject_item']" v-for="(item,index) in subjectList"
            :key="index" @click="changeSubject(index)">{{item.name}}</span>
    </div>
    <div class="setting_detail_wrapper">
      <div class="type_list">
        <draggable v-model="settingList">
          <transition-group>
            <span :class="[selectedSetting == index ? 'setting_item selected_setting' :'setting_item ']" v-for="(item,index) in settingList"
                  :key="item" @click="changeSetting(index)">{{item}}</span>
          </transition-group>
          <Button slot="footer" icon="md-add" type="primary" ghost class="add_setting" @click="addSetting">添加新类型</Button>
        </draggable>
      </div>
      <div class="config_detail">
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤1</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤2</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤3</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤1</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤2</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤3</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤1</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤2</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤3</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤1</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤2</p>
        <p style="line-height:120px;font-size: 30px;color:#999;">挤挤3</p>
      </div>
    </div>
  </div>
</template>
<script>
  import draggable from 'vuedraggable';
  import paging from "../templates/Paging.vue";
  import { alertTips } from "../common/common";
  import {_getBasicsConfigInfo,_getQuestionTypeList,_getSubjectList} from '../api/api';
  export default {
    components:{draggable},
    data() {
      return {
        configTitle: '',
        currentSelectedSubject:0,// 当前选中科目index
        selectedSetting:0,// 选中的规则index
        subjectList: [],// 科目列表
        questionTypeList:{},// 题型列表
        selectedSubject:'',// 选中的科目
        selectedQuestionType:'',//选中的题型
        selectedParams:'',// 选中的参数
        basicsConfigList:{},//基础配置参数
        settingList:['选择题-答案包含A-D任意字符', '选择题-答案包含E-Z任意字符', '选择题-答案包含带圈数字', '判断题-答案包含勾叉', '问答题']
      }
    },
    methods: {
//    获取测试配置基础参数
      getBasicsConfigInfo(){
        const self = this;
        _getBasicsConfigInfo().then(res => {
          if(res.code === 0) {
            for(let key in res.data){
              switch (key) {
                case 'answerConditionType':
                  key = '答案条件';
                  break;
                case 'resultOperationType':
                  key = '结果类型';
                  break;
                case 'compareConditionType':
                  key = '判断条件';
                  break;
                case 'customResourcesType':
                  key = '自定义';
                  break;
                case 'subjectType':
                  key = '科目';
                  break;
              }
            }
            this.basicsConfigList = res.data;
          }else {
            alertTips('warning',res.message);
          }
        })
      },
      // 获取题目类型列表
      getQuestionTypeList(){
        const self = this;
        _getQuestionTypeList().then(res => {
          if(res.code === 0) {
            this.questionTypeList = res.data;
          }else {
            alertTips('warning',res.message);
          }
        })
      },
//      切换科目
      changeSubject(index){
        if(this.currentSelectedSubject != index) {
          this.currentSelectedSubject = index;
        }
      },
//      切换规则
      changeSetting(index){
        if(this.selectedSetting != index) {
          this.selectedSetting = index;
        }
      },
//      添加新规则
      addSetting(){

      },
    },
    updated(){

    },
    mounted(){
      this.getBasicsConfigInfo();
      this.getQuestionTypeList();
    }
  };
</script>
<style scoped>
  .detail_wrapper{
    height:100%;
  }
  .title_wrapper {
    display: flex;
  }
  .title_wrapper .config_title {
    display: inline-block;
    margin-right: 6px;
    line-height: 32px;
  }
  .title_wrapper .title_ipt {
    flex: 1;
  }
  .subject_list_wrapper {
    padding-top: 10px;
  }
  .subject_list_wrapper .subject_item {
    display: inline-block;
    width: 82px;
    height: 30px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: 0 0 4px #2d8cf0;
    -moz-box-shadow: 0 0 4px #2d8cf0;
    box-shadow: 0 0 4px #2d8cf0;
    margin:0 10px 10px 0;
    line-height: 30px;
    font-size:16px;
    text-align: center;
    color: #333;
    cursor:pointer;
  }
  .subject_list_wrapper .subject_item_active {
    background:#2d8cf0;
    color: #fff;
  }
  .setting_detail_wrapper {
    position: relative;
    height:calc(100% - 82px);
    overflow:hidden;
  }
  .setting_detail_wrapper .type_list {
    position: absolute;
    top:0;
    left:0;
    overflow-x: hidden;
    overflow-y: scroll;
    width:200px;
    height:100%;
    padding-right:10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-right:10px;
  }
  .setting_detail_wrapper .type_list::-webkit-scrollbar{
    width:4px;
  }
  .setting_detail_wrapper .type_list::-webkit-scrollbar-thumb{
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-shadow: inset 0px 0px 5px #ccc;
    -moz-box-shadow: inset 0px 0px 5px #ccc;
    box-shadow: inset 0px 0px 5px #ccc;
    background:#aaa;
  }
  .setting_detail_wrapper .type_list::-webkit-scrollbar-track{
    width:4px;
    background:#eee;
  }
  .type_list .setting_item{
    display: block;
    padding:3px 6px;
    margin-bottom:8px;
    line-height: 24px;
    font-size:14px;
    color:#333;
    background:#eee;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    cursor: pointer;
  }
  .type_list .selected_setting{
    font-weight:bold;
    color:#2d8cf0;
    background:#fff;
   }
  .type_list .add_setting{
    display: block;
    width:100%;
  }
  .setting_detail_wrapper .config_detail {
    position: absolute;
    top:0;
    left:210px;
    height:100%;
    width:calc(100% - 210px);
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .setting_detail_wrapper .config_detail::-webkit-scrollbar{
    width:4px;
  }
  .setting_detail_wrapper .config_detail::-webkit-scrollbar-thumb{
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-shadow: inset 0px 0px 5px #ccc;
    -moz-box-shadow: inset 0px 0px 5px #ccc;
    box-shadow: inset 0px 0px 5px #ccc;
    background:#aaa;
  }
  .setting_detail_wrapper .config_detail::-webkit-scrollbar-track{
    width:4px;
    background:#eee;
  }
  .selection_list_wrapper{
    display: flex;
    flex-direction:row;
    flex-wrap: wrap;
  }
  .selection_list_wrapper .selection_item{
    width:33.3%;
    display: flex;
  }
  .selection_item .item_label{
    display: inline-block;
    height:30px;
    margin:10px 6px 0 0;
    line-height:30px;
  }
  .selection_item .select_info{
    flex:1;
    margin:10px 12px 0 0;
  }
  .selection_list_wrapper .selection_item:nth-child(3n) .select_info{
    margin-right: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/OCRSettingDetail.vue